export default __webpack_public_path__ + "static/10-omineca-label-3d5752d22a50bc2dbdcf32e9095b1768.svg";